<template>
    <div id="customConfirmationDialog" v-if="isReportConfirmationDialogOpen">
        <div @click="() => changeReportModalState(false)"
            :class="`modal-backdrop ${isReportConfirmationDialogOpen ? '' : 'hidden'}`"></div>
        <div id="popupModal" tabindex="-1">
            <!-- modal body -->
            <div class="fixed modal-inner z-[150] sm:w-full w-[90%] max-w-xl max-h-full">
                <div class="relative bg-white rounded-lg modal_inner_dialog">
                    <!-- close button -->
                    <button @click="() => changeReportModalState(false)" type="button"
                        class="absolute top-1 left-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>

                    <!--modal content p-[2rem_5rem] -->
                    <div class="sm:p-[2rem_5rem] p-[1.55rem_1.5rem] text-center">
                        <h1 class="text-[1rem] font-extrabold">{{ $t('user.report_product') }}</h1>
                        <div class="flex flex-col mt-5 gap-1 mb-3">
                            <div v-for="(reason, i) in reasons" :key="i" class="flex items-start justify-start gap-3 mb-1">
                                <input :id="`default-radio-${i}`" :value="reason" @input="$emit('update:selectedReason', $event.target.value)" type="radio"
                                    name="default-radio"
                                    class="w-4 h-4 text-[#346cf8] bg-[#e4e4e4bf] border-[#ffffff] focus:ring-[#458cfc] focus:ring-1" />
                                <label for="default-radio-1"
                                    class="sm:text-[.8rem] text-[.75rem] text-center font-bold text-gray-900">{{ $t(`general.reports.${reason}`) }}</label>
                            </div>
                            <textarea :value="opinion" @input="$emit('update:opinion', $event.target.value)" name="textarea"
                                :class="`resize-none w-full h-20  mt-2 bg-[#FFFFFF] border-[#D8D8D8] outline-none placeholder:text-[#bebebe] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2.5`"
                                :placeholder="$t(`general.reports.write_your_opinion`)"></textarea>
                        </div>
                        <!-- sm:px-14 sm:py-2.5 px-10 py-1.5  -->
                        <div class="flex justify-start items-center gap-2">
                            <button :disabled="isReportingProduct" @click="() => makeCompliant()" type="button"
                                :class="`${isReportingProduct ? 'disabled' : ''} text-white bg-[#0963FF] sm:w-[30%] w-full sm:py-2.5 py-2  sm:text-sm text-xs hover:bg-[#0963ffd6]  border border-gray-200 focus:ring-4 focus:outline-none font-medium rounded-lg    mr-2`">{{
                                    $t(`general.confirm`) }}</button>
                            <button :disabled="isReportingProduct" @click="() => changeReportModalState(false)"
                                type="button"
                                :class="`${isReportingProduct ? 'disabled' : ''} text-black bg-[#d1d1d1] sm:w-[30%] w-full sm:py-2.5 py-2 sm:text-sm text-xs hover:bg-[#d1d1d1cf] focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200  font-medium  hover:text-gray-900 focus:z-10`">{{
                                    $t(`general.cancel`) }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isReportConfirmationDialogOpen:{
            type: Boolean,
            required: true,
            default: false
        },
        changeReportModalState: {
            type: Function,
            required: true
        },
        makeCompliant: {
            type: Function,
            required: true
        },
        opinion: {
            type: String,
            required: true,
            default: ""
        },
        reasons: {
            type: Array,
            required: true,
            default: () => ([])
        },
        selectedReason: {
            type: String,
            required: true,
            default: ""
        },
        isReportingProduct: {
            type: Boolean,
            required: true,
            default: false
        }
    }
}
</script>

<style></style>